import { ActionReducerMap } from '@ngrx/store';
import { fromAuth, Auth } from '@content-platform/web-angular-shared-util-auth';
import * as fromRouter from '@ngrx/router-store';
import { Params, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { routerReducer } from '@ngrx/router-store';
import { fromApplication } from '@content-platform/web/angular/shared/data-access/application-api';
import { Injectable } from '@angular/core';

export interface RouterStateUrl {
  url: string;
  queryParams: Params;
  params: Params;
}

export interface HomeState {
  auth: Auth;
  application: fromApplication.State;
  routerReducer: fromRouter.RouterReducerState<RouterStateUrl>;
}

export const reducers: ActionReducerMap<HomeState> = {
  auth: fromAuth.authReducer,
  application: fromApplication.reducer,
  routerReducer: routerReducer,
};

@Injectable()
export class CustomSerializer implements fromRouter.RouterStateSerializer<RouterStateUrl> {
  serialize(routerState: RouterStateSnapshot): RouterStateUrl {
    const { url } = routerState;
    const { queryParams } = routerState.root;

    let state: ActivatedRouteSnapshot = routerState.root;
    while (state.firstChild) {
      state = state.firstChild;
    }
    const { params } = state;

    return { url, queryParams, params };
  }
}
